// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"95":"d7978c97","384":"f5edabb4","445":"c1141ccf","491":"dfc9ed5d","578":"eea9d38e"}[chunkId] + ".chunk.css";
};